import CountryInput from '@/components/FormItems/CountryInput';
import AppDatePicker from '@/components/FormItems/DatePicker';
import StationInput from '@/components/FormItems/StationInput';
import { DEFAULT_DATE_FORMAT, ROW_GUTTER } from '@/config';
import { Form, Row, Col, Button, Space, Input } from 'antd';
import moment, { Moment } from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LeftOutlined, RightOutlined, SearchOutlined, CloseOutlined } from '@ant-design/icons';

type Props = {
  onSearch: (values: any) => void;
};

const size = {
  md: 12,
  xl: 4,
  xxl: 3,
};
export default function SearchForm({ onSearch }: Props) {
  const { t } = useTranslation();
  const [searchForm] = Form.useForm();
  const sourceCountryId = Form.useWatch('sourceCountryId', searchForm);
  const destinationCountryId = Form.useWatch('destinationCountryId', searchForm);
  const onFinish = values => {
    onSearch({ ...values, departureDate: moment(values.departureDate).format(DEFAULT_DATE_FORMAT) });
  };
  const onNextPrevDay = (offset: number) => {
    var currentDate: Moment = searchForm.getFieldValue('departureDate');
    if (currentDate) {
      var nextDay = moment(currentDate).add(offset, 'day');
      if (nextDay.isAfter(moment().startOf('day'))) {
        searchForm.setFieldValue('departureDate', nextDay);
        searchForm.submit();
      }
    }
  };
  return (
    <Form
      className="nta-custom-form"
      layout="vertical"
      form={searchForm}
      onFinish={onFinish}
      initialValues={{ departureDate: moment() }}
      style={{ marginTop: 10 }}
    >
      <Row gutter={ROW_GUTTER}>
        <Col {...size} xxl={4}>
          <Form.Item label={t('tripDetailsPage_DepartureDate')} rules={[{ required: true, message: '' }]}>
            <div style={{ display: 'flex', width: '100%' }}>
              <Button
                icon={<LeftOutlined />}
                onClick={() => {
                  onNextPrevDay(-1);
                }}
              />
              <div style={{ flex: 1, marginLeft: 5, marginRight: 5 }}>
                <Form.Item name="departureDate" rules={[{ required: true, message: '' }]}>
                  <AppDatePicker className="w-100" allowClear={false} disabledDate={v => v.isBefore(moment().startOf('day'))} />
                </Form.Item>
              </div>
              <Button
                icon={<RightOutlined />}
                onClick={() => {
                  onNextPrevDay(1);
                }}
              />
            </div>
          </Form.Item>
        </Col>
        <Col {...size}>
          <Form.Item label={t('tripDetailsPage_SearchText')} name="searchText">
            <Input placeholder={t('tripDetailsPage_SearchText')} />
          </Form.Item>
        </Col>
        <Col {...size}>
          <Form.Item label={t('tripDetailsPage_SourceCountry')} name="sourceCountryId">
            <CountryInput
              placeholder={t('tripDetailsPage_SourceCountry')}
              onChange={() => {
                searchForm.setFieldValue('sourceStationId', null);
              }}
            />
          </Form.Item>
        </Col>
        <Col {...size}>
          <Form.Item label={t('tripDetailsPage_SourceStation')} name="sourceStationId">
            <StationInput
              placeholder={t('tripDetailsPage_SourceStation')}
              countryIds={sourceCountryId ? [sourceCountryId] : undefined}
              disabled={!sourceCountryId}
            />
          </Form.Item>
        </Col>
        <Col {...size}>
          <Form.Item label={t('tripDetailsPage_DestinationCountry')} name="destinationCountryId">
            <CountryInput
              placeholder={t('tripDetailsPage_DestinationCountry')}
              onChange={() => {
                searchForm.setFieldValue('destinationStationId', null);
              }}
            />
          </Form.Item>
        </Col>
        <Col {...size}>
          <Form.Item label={t('tripDetailsPage_DestinationStation')} name="destinationStationId">
            <StationInput
              placeholder={t('tripDetailsPage_DestinationStation')}
              countryIds={destinationCountryId ? [destinationCountryId] : undefined}
              disabled={!destinationCountryId}
            />
          </Form.Item>
        </Col>
        <Col {...size}>
          <Form.Item label="&nbsp;" style={{ textAlign: 'left' }}>
            <Space>
              <Button type="primary" htmlType="submit">
                <SearchOutlined />
                {t('zTable.search')}
              </Button>
              <Button type="ghost" htmlType="reset">
                <CloseOutlined />
                {t('zTable.reset')}
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
